/**************************************************
 * Nombre:       Boton
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Box, Button, IconButton} from "@mui/material";
import {ArrowForward} from "@mui/icons-material";
import {theme} from "../../../../Tema";
import {COLORTEXTO} from "../../../../Constantes";


const Boton = ({color = 'primary', texto = 'Ingresar', click}) => {

    return (
        <Box>
            <Button
                color={color}
                onClick={(e) => click()}
                //sx={{color: theme.palette.primary.main}}
            >
                {texto}
            </Button>

            <IconButton
                onClick={(e) => click()}
                sx={{backgroundColor: color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main}}>
                <ArrowForward sx={{fill: color === 'primary' ? '#fff' : COLORTEXTO, p: 1, width: 20, height: 20}}/>
            </IconButton>
        </Box>
    )

}
export default Boton